import React from 'react'
import Layout from "../../components/Layout/Layout";


function Index() {
  return (
    <Layout title="Medarc Users" pageTitle="users">
        <div className="section">

        </div>
    </Layout>
  )
}

export default Index